module.exports = __webpack_public_path__ + "img/purpose_consolidation.5787db83.svg";